import React from 'react'
import {BookConsultation} from "./steps/book_consultation";
import footerImg from '../../../../../assets/images/leadPages/footer-img-2.png'
import {ServicesList} from "./steps/book_consulation/services_list";
import {SERVICES} from "../../../../../assets/images/servicesPages";
import ServiceLogoListComponent from "../../home_page/homeComponents/ServiceLogoListComponent";
import { Helmet } from 'react-helmet-async';
import { Link, withRouter } from "react-router-dom";
import { connect } from "react-redux";

const hdrListItems = [
  {
    title: 'Easy Booking and 24 Hour Turnaround',
    description: 'Schedule your shoot in minutes and get your photos, videos and interactive tours next day.',
    icon: SERVICES.ListIcon3
  },
  {
    title: 'Photographers Who Know Real Estate',
    description: 'Work with experienced local professionals who understand how to capture homes for today’s market.',
    icon: SERVICES.ListIcon2
  },
  {
    title: 'Media Designed to Sell Homes Faster',
    description: 'Real estate photography designed to attract more buyers and sell homes faster.',
    icon: SERVICES.ListIcon1
  }
]

export const ScheduleConsultationPage = (props) => {

  const onGetStarted = (e) => {
    e.preventDefault()
    if (props.currentUser) {
      props.history.push("/create-project")
    } else {
      props.setModal(true);
    }
  }

  return <div className="apply-for-discount">
    <Helmet>
      <title>Book a Real Estate Photographer Near You | Modern Angles</title>
      <link rel="canonical" href={window.location.href} />
      <meta
        name="description"
        content="Book Top-Rated Photographers & Get Stunning Photos, Drone Shots, Videos, Floor Plans & Virtual Staging – Delivered within 24 Hours."
      />
    </Helmet>
    <BookConsultation/>

    <div className="footer-container apply-for-discount-book-consultation-container">
      <ServiceLogoListComponent />

      <div className="lead-page-divider" />

      <div className="apply-for-discount-book-consultation-sections apply-for-discount-footer-sections">
        <div className="apply-for-discount-footer-side-image">
          <img src={footerImg} />
        </div>

        <div>
          <h1>Why agents choose us:</h1>

          <ServicesList items={hdrListItems}/>

          <button className="projectEditButton projectEditButtonBlue projectEditButtonLarger"
                  onClick={onGetStarted}>
            Schedule Shoot
          </button>
        </div>
      </div>
    </div>
  </div>
}